import React from 'react'

const Paperclip = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fill='currentcolor'
      d='M5.75 11C4.98333 11 4.33333 10.7333 3.8 10.2C3.26667 9.66667 3 9.01667 3 8.25V3C3 2.45 3.19583 1.97917 3.5875 1.5875C3.97917 1.19583 4.45 1 5 1C5.55 1 6.02083 1.19583 6.4125 1.5875C6.80417 1.97917 7 2.45 7 3V7.75C7 8.1 6.87917 8.39583 6.6375 8.6375C6.39583 8.87917 6.1 9 5.75 9C5.4 9 5.10417 8.87917 4.8625 8.6375C4.62083 8.39583 4.5 8.1 4.5 7.75V3H5.25V7.75C5.25 7.89167 5.29792 8.01042 5.39375 8.10625C5.48958 8.20208 5.60833 8.25 5.75 8.25C5.89167 8.25 6.01042 8.20208 6.10625 8.10625C6.20208 8.01042 6.25 7.89167 6.25 7.75V3C6.25 2.65 6.12917 2.35417 5.8875 2.1125C5.64583 1.87083 5.35 1.75 5 1.75C4.65 1.75 4.35417 1.87083 4.1125 2.1125C3.87083 2.35417 3.75 2.65 3.75 3V8.25C3.75 8.8 3.94583 9.27083 4.3375 9.6625C4.72917 10.0542 5.2 10.25 5.75 10.25C6.3 10.25 6.77083 10.0542 7.1625 9.6625C7.55417 9.27083 7.75 8.8 7.75 8.25V3H8.5V8.25C8.5 9.01667 8.23333 9.66667 7.7 10.2C7.16667 10.7333 6.51667 11 5.75 11Z'
    />
  </svg>
)

export default Paperclip
